var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { SourceType } from '@debbie/common/dist/cosmo/events';
import THEME from '../../../theme';
import Badge from '../../Badge';
import Clock from '../../Icons/Clock';
import Edit from '../../Icons/Edit';
import Input from '../../Input';
import Modal from '../../Modal';
import PerformedBy from '../../performed-by/PerformedBy';
const UserInfoEntity = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [histOpen, setHistOpen] = useState(false);
    const [value, setValue] = useState(props.value);
    useEffect(() => {
        if (!editing)
            setValue(props.value);
    }, [props.value]);
    useEffect(() => {
        document.addEventListener('keydown', onEscapePress);
        return () => document.removeEventListener('keydown', onEscapePress);
    }, []);
    const onEscapePress = (evt) => {
        const event = evt || window.event;
        if (event.code === 'Escape') {
            if (editing) {
                setValue(props.value);
                toggleEdit();
            }
        }
        else if (event.code === 'Enter' && !props.renderEditor && editing) {
            save(value);
        }
    };
    const toggleHist = () => setHistOpen(!histOpen);
    const toggleEdit = () => setEditing(!editing);
    const save = (value) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            props.onChange && (yield props.onChange(value));
        }
        catch (err) {
            console.log(err);
            alert(err);
        }
        setLoading(false);
        setEditing(false);
    });
    const remove = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            props.onChange && (yield props.onChange(null));
        }
        catch (err) {
            console.log(err);
            alert(err);
        }
        setValue(null);
        setLoading(false);
        setEditing(false);
    });
    return (React.createElement(UserInfoEntityStyled, null,
        React.createElement("h3", null,
            props.title,
            props.tags &&
                props.tags.map((tag) => (React.createElement(Badge, { style: {
                        verticalAlign: 'middle',
                        marginLeft: '.7em',
                        fontSize: '.7em',
                    }, theme: tag.theme || THEME.COLOR_ACCENT }, tag.content))),
            React.createElement("div", { style: { float: 'right' } },
                props.nextToInfo,
                props.hist && (React.createElement(Clock, { style: { cursor: 'pointer' }, onClick: toggleHist })),
                props.onChange && site === Site.Caseworker && (React.createElement(Edit, { style: { cursor: 'pointer', marginLeft: '5px' }, onClick: toggleEdit }))),
            histOpen && (React.createElement(Modal, { maxWidth: "300px", header: `${props.title} History`, onToggle: toggleHist },
                React.createElement("h2", { style: { fontSize: '1.2em' } }, props.renderValue ? props.renderValue(props.value) : props.value),
                props.hist ? (React.createElement("div", null,
                    React.createElement("h3", { style: {
                            textTransform: 'uppercase',
                            fontSize: '0.9em',
                            color: '#4a4a4a',
                        } }, lang.debtorInfo.previous),
                    React.createElement("div", null,
                        React.createElement(EventHist, { events: props.hist, renderValue: props.renderValue })))) : (React.createElement("p", null, lang.debtorInfo.noPreviousToShow))))),
        editing ? (props.renderEditor ? (props.renderEditor((selectedValue) => {
            save(selectedValue);
            setValue(selectedValue);
        })) : (React.createElement("div", null,
            React.createElement(Input, { autofocus: true, style: { marginBottom: '0' }, value: value, onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                    setValue(e.target.value);
                }), placeholder: props.title, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        save(value);
                    }
                }, button: value !== props.value
                    ? {
                        loading: loading,
                        onClick: () => save(value),
                        value: lang.inputs.save,
                        disabled: props.validate && !props.validate(value),
                    }
                    : props.removable
                        ? {
                            loading: loading,
                            onClick: remove,
                            value: lang.inputs.remove,
                        }
                        : undefined })))) : props.renderValue ? (props.renderValue(value)) : (value || React.createElement("span", { style: { opacity: 0.5 } }, props.title))));
};
export default UserInfoEntity;
const EventHist = (props) => {
    return (React.createElement("div", null, props.events.map((cosmoEvent) => {
        return (React.createElement(ListItem, { key: cosmoEvent.cosmoEventId },
            React.createElement("h4", null,
                props.renderValue
                    ? props.renderValue(cosmoEvent.value)
                    : cosmoEvent.value,
                React.createElement("span", { style: { float: 'right' } }, cosmoEvent.createdBy &&
                    cosmoEvent.source === SourceType.USER ? (React.createElement(PerformedBy, { performedBy: cosmoEvent.createdBy })) : (React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, cosmoEvent.source)))),
            React.createElement("p", null, cosmoEvent.createdAt &&
                moment(cosmoEvent.createdAt).format(THEME.DATE_FORMAT_LONG))));
    })));
};
const ListItem = styled.div `
  padding: 10px 0;
  font-size: 0.9em;
  border-bottom: 1px solid darkgrey;

  &:last-child {
    border-bottom: none;
  }

  p {
    font-size: 0.7em;
    margin-top: 0.3em;
    opacity: 0.6;
    font-weight: bold;
  }

  p,
  h4 {
    margin: 0;
  }
`;
const UserInfoEntityStyled = styled.div `
  padding-bottom: ${THEME.GRID_SPACING}px;
`;
//# sourceMappingURL=UserInfoEntity.js.map